import axios from 'axios'

const state = {

};

const mutations = {

};

const actions = {
  sendEmail({commit}, emailInfo) {
    console.log(emailInfo.email)
    console.log(emailInfo.userID)
    axios.post('/email/',
        {
          subject: emailInfo.subject,
          message: emailInfo.message,
          from_address: emailInfo.from,
          to_address: emailInfo.email,
          reply_address: emailInfo.reply,
          user_id: emailInfo.userID,
        }
      )
        .then(res => {
          console.log('Email Sent')
          console.log(res)
        })
        .catch(error => console.log(error))
  },
  commsAlive() {
    console.log('Comms Alive!!')
  },
  sendMasivSMS({commit}, SMSInfo) {
    console.log('Sending Masiv SMS')
    console.log(SMSInfo)

    // axios.post('https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
    axios.post('https://cors-anywhere.herokuapp.com/https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
      .then(res => {
        console.log(res)
      })
      .catch(error => console.log(error))
  },
};

const getters = {

};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/communication.js